// extracted by mini-css-extract-plugin
export default {"root":"CommunityPage_root__X4dhO","iframeContainer":"CommunityPage_iframeContainer__Bx1pZ","iframe":"CommunityPage_iframe__xtsN8"};